../<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s account name or account number or customer id is required')"
          />

          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="chequeDepositRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="3">
                    <InputField
                      id="account-name"
                      v-model="customer.accountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-number"
                      v-model="depositData.accountNumber"
                      :label="$t('Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="NUBAN"
                      v-model="customer.accountNumber"
                      label="NUBAN"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="available-balance"
                      v-model="customer.availableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="withdrawable-balance"
                      v-model="customer.withdrawableBalance"
                      :label="$t('Withdrawable Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <InputField
                      id="overdraft-limit"
                      v-model="customer.overdraftLimit"
                      :label="$t('Overdraft Limit')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="account-officer"
                      v-model="customer.accountOfficer"
                      :label="$t('Account Officer')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <InputField
                      id="tier-level"
                      v-model="customer.accountTierLevel"
                      :label="$t('Tier Level')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-2 mt-4">
              {{ $t('Cheque Details') }}
            </h5>
            <b-row>
              <b-col md="4">
                <InputField
                  id="drawer-name"
                  v-model="depositData.drawerName"
                  :label="$t('Drawer Name')"
                  :placeholder="$t('Enter drawer name')"
                  :error-name="$t('Drawer Name')"
                  rules="required"
                  type="text"
                  :on-input="setDrawerNameNarration"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>

              <b-col md="4">
                <SelectField
                  id="drawer-bank"
                  v-model="depositData.drawerBank"
                  :label="$t('Drawer Bank')"
                  :options="bankOptions"
                  :placeholder="$t('Select')"
                  :reduce="option => option.value"
                  item="label"
                  rules="required"
                  :error-name="$t('Drawer Bank')"
                  :set-selected="setDrawerBankNarration"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="drawer-bank-branch"
                  v-model="depositData.drawerBankBranch"
                  :label="$t('Drawer Bank Branch')"
                  :placeholder="$t('Enter drawer bank branch')"
                  type="text"
                  rules="required"
                  :error-name="$t('Drawer Bank Branch')"
                />
              </b-col>
              <b-col md="4">
                <InputField
                  id="drawer-account-number"
                  v-model="depositData.drawerAccountNumber"
                  :label="$t('Drawer Account Number')"
                  :placeholder="$t('Enter drawer account number')"
                  type="number"
                  rules="required"
                  :error-name="$t('Drawer Account Number')"
                  :on-input="setDrawerNumberNarration"
                />
              </b-col>
              <b-col md="4">
                <DatePickerField
                  id="date-on-cheque"
                  v-model="depositData.dateOnCheque"
                  rules="required"
                  :label="$t('Date on Cheque')"
                  :error-name="$t('Date on cheque')"
                  :placeholder="$t('Select Date on Cheque')"
                  :config="datePickerConfig"
                  readonly
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="cheque-number"
                  v-model="depositData.chequeNumber"
                  :label="$t('Cheque Number')"
                  :placeholder="$t('Enter cheque number')"
                  type="number"
                  rules="required"
                  :error-name="$t('Cheque Number')"
                  :on-input="setChequeNumberNarration"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="cheque-number"
                  v-model="depositData.sortCode"
                  :label="$t('Sort Code')"
                  :placeholder="$t('Enter sort code')"
                  type="number"
                  rules="required"
                  :error-name="$t('Sort Code')"
                />
              </b-col>
            </b-row>

            <h5 class="text-capitalize mb-2 mt-4">
              {{ $t('Post Details') }}
            </h5>
            <b-row>
              <b-col md="4">
                <SelectField
                  id="clearing-bank"
                  v-model="depositData.clearingBank"
                  label="Clearing Bank"
                  :options="clearingBankOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  item="label"
                  rules="required"
                  :set-selected="setClearingMirrorGL"
                  error-name="Clearing Bank"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="clearing-bank"
                  v-model="depositData.clearingBankMirrorGL"
                  label="Clearing Bank Mirror GL"
                  type="text"
                  rules="required"
                  readonly
                />
              </b-col>

              <b-col md="4">
                <InputNumberField
                  id="amount"
                  v-model="depositData.amount"
                  :label="$t('Amount on Cheque')"
                  :placeholder="$t('Enter Amount on Cheque')"
                  rules="required|positive"
                  :error-name="$t('Amount on Cheque')"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="narration"
                  v-model="depositData.narration"
                  :label="$t('Narration')"
                  :placeholder="$t('Enter narration')"
                  type="text"
                  rules="required"
                  error-name="narration"
                />
              </b-col>
            </b-row>

            <h5 class="text-capitalize mb-2 mt-4">
              {{ $t('Clearing Day') }}
            </h5>
            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="ignoreSystemDefaultClearing"
                  :label="$t('Ignore System Default')"
                  name="ignore-system"
                  class="mt-2"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <InputNumberField
                  id="clearing-days"
                  v-model="depositData.clearingDays"
                  :label="$t('Clearing Days')"
                  :placeholder="$t('Enter clearing days')"
                  rules="required"
                  :error-name="$t('Clearing Days')"
                  :on-input="setClearingDate"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="clearing-date"
                  v-model="depositData.clearingDate"
                  :label="$t('Clearing Date')"
                  type="text"
                  readonly
                />
              </b-col>
            </b-row>

            <h5 class="text-capitalize mb-2 mt-4">
              {{ $t('Cheque Commission') }}
            </h5>
            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="ignoreSystemDefaultCheque"
                  :label="$t('Ignore System Default')"
                  name="ignore-system"
                  class="mt-2"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <InputField
                  id="percentage"
                  v-model.number="depositData.chequeCommissionPercentage"
                  :label="$t('Percentage')"
                  :placeholder="$t('Enter percentage')"
                  type="number"
                  :on-input="setCommissionPercentage"
                />
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="commission"
                  v-model="commission"
                  :label="$t('Commission')"
                  readonly
                />
              </b-col>
            </b-row>

            <div class="text-center mt-5">
              <Button
                :label="$t('Post')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="handleSubmit"
              />
            </div>

          </validation-observer>

        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>
    <b-modal
      id="memo-info-modal"
      ref="memoInfoModal"
      :ok-title="$t('Cancel')"
      ok-only
      :title="$t('Memo')"
      ok-variant="outline-secondary"
      centered
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        ref="memoListTable"
        select-mode="single"
        :items="memoGetData"
        responsive
        :fields="translatedMemoListHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No data available')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
      >
        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>
      </b-table>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive, amount } from '@validations'
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toKobo, toAmount } from '@/helpers/formatAmount'
import getEndDate from '@/helpers/getEndDate'
import { toYearWithDate, toDateWithYear } from '@/helpers/formatDate'
import InputField from '../../../../forms/InputField.vue'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import SelectField from '../../../../forms/SelectField.vue'
import { postingPermissions } from '@/helpers/permissions'

const today = new Date()
const dateTime = moment(today).format()

export default {
  components: {
    BRow,
    BCol,
    InputField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    DatePickerField,
    AppCollapse,
    AppCollapseItem,
    InputNumberField,
    SwitchButton,
    SelectField,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      amount,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      isLoading: false,
      isLoadingBanks: false,
      isDisabled: false,
      customerList: [],
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      commission: '',
      selected: [],
      perPage: 10,
      sortBy: 'accountName',
      tillAccountNumber: '',
      filteredResult: [],
      clearingBankOptions: [],
      searchParams: {
        accountNumber: null,
        accountName: null,
        referenceNumber: null,
      },
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        // defaultDate: '',
      },
      depositData: {
        drawerName: '',
        drawerBank: '',
        drawerBankName: '',
        drawerBankBranch: '',
        drawerAccountNumber: '',
        dateOnCheque: '',
        chequeNumber: '',
        sortCode: '',
        accountNumber: '',
        clearingBank: '',
        clearingBankMirrorGL: '',
        amount: ' ',
        narration: '',
        clearingDays: 0,
        clearingDate: '',
        chequeCommissionPercentage: 0,
        instrumentNumber: '',
      },
      postingFormData: {
        postingData: {
          realDate: dateTime,
          postingType: 'ChequeDepositPosting',
          senderName: '',
        },
      },
      posting: [],
      ignoreSystemDefaultClearing: false,
      ignoreSystemDefaultCheque: false,
      clearingDays: '',
      chequeCommissionPercentage: '',
      customer: {
        accountName: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        availableBalance: '',
        withdrawableBalance: '',
        overdraftLimit: '',
        accountOfficer: '',
        accountTierLevel: '',
        minimumBalanceRequired: 0,
        accountCreationChannel: null,
        accountNumber: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
      memoListHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountNumber', label: 'Account Number' },
        { key: 'actionType', label: 'Action Type' },
        { key: 'details', label: 'Reason' },
        { key: 'comments', label: 'Comments' },
        { key: 'initiatedBy', label: 'Initiated By' },
      ],
      memoGetData: [],

    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userData: 'auth/getCurrentUser',
      tillAccounts: 'operations/getTillAccount',
      bankOptions: 'operations/bankOptions',
      currentFinancialDate: 'operations/getCurrentFinancialDate',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedMemoListHeaders() {
      return this.memoListHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  watch: {
    ignoreSystemDefaultClearing(newValue) {
      this.setSystemDefaultClearing(newValue)
    },
    ignoreSystemDefaultCheque(newValue) {
      this.setSystemDefaultCheque(newValue)
    },
  },
  mounted() {
    this.datePickerConfig.defaultDate = toDateWithYear(this.currentFinancialDate.financialDate)
    this.depositData.dateOnCheque = toDateWithYear(this.currentFinancialDate.financialDate)
    this.getAccounts()
    this.fetchOtherConfiguration()
  },
  methods: {
    ...mapActions({
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      postChequeDeposit: 'posting/chequeDepositAction',
      getUserBalance: 'account/getCASABalanceAction',
      getAccountCategoryByCode: 'account/getAccountCategoryByCode',
      getChequeClearingAccountList: 'operations/getChequeClearingAccountList',
      getOtherConfiguration: 'operations/getOtherConfigurationList',
    }),
    setClearingMirrorGL(value) {
      this.depositData.clearingBankMirrorGL = value
    },
    setClearingDate(val) {
      if (val) {
        this.depositData.clearingDate = getEndDate(toDateWithYear(this.currentFinancialDate.financialDate), val)
        return true
      }
      this.depositData.clearingDate = ''
      return false
    },
    setCommissionPercentage(val) {
      if (val && this.depositData.amount) {
        this.commission = this.depositData.amount * (val / 100)
        return true
      }
      this.commission = ''
      return false
    },
    // setNarration(val) {
    //   this.depositData.narration = `Chq dep.: ${this.depositData.drawerBank} Chq.No ${this.depositData.instrumentNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    //   if (val && this.depositData.chequeCommissionPercentage) {
    //     this.commission = val * (this.depositData.chequeCommissionPercentage / 100)
    //     return true
    //   }
    //   this.commission = ''
    //   return false
    // },
    async getAccounts() {
      try {
        const response = await this.getChequeClearingAccountList({
          search: {},
          page: 1,
          limit: 200,
          permission: postingPermissions.VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING,
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.clearingBankOptions = data.data.map(item => ({
            label: item.accountName,
            value: item.accountNumber.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchOtherConfiguration() {
      try {
        const response = await this.getOtherConfiguration({ permission: postingPermissions.VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.depositData.clearingDays = data.data.defaultChequeClearingDurationInDays
          this.depositData.chequeCommissionPercentage = data.data.commissionOnCheques
          this.clearingDays = data.data.defaultChequeClearingDurationInDays
          this.chequeCommissionPercentage = data.data.commissionOnCheques
          // this.isChequeCommissionRequired = data.data.applyCommissionOnChequeDeposit
          this.setClearingDate(this.depositData.clearingDays)
          this.setCommissionPercentage(this.depositData.chequeCommissionPercentage)
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    setSystemDefaultClearing(value) {
      if (value) {
        this.depositData.clearingDays = ''
        this.depositData.clearingDate = ''
        return false
      }
      this.depositData.clearingDays = this.clearingDays
      this.setClearingDate(this.depositData.clearingDays)
      return true
    },
    setSystemDefaultCheque(value) {
      if (value) {
        this.depositData.chequeCommissionPercentage = ''
        this.commission = ''
        return false
      }
      this.depositData.chequeCommissionPercentage = this.chequeCommissionPercentage
      this.setCommissionPercentage(this.depositData.chequeCommissionPercentage)
      return true
    },
    setDrawerNameNarration(val) {
      let drawerBank
      if (this.depositData.drawerBank) {
        drawerBank = this.bankOptions.find(item => item.value === this.depositData.drawerBank)
      }

      this.depositData.drawerName = val
      this.depositData.narration = `Chq dep.: ${drawerBank ? drawerBank.label : ''} Chq.No ${this.depositData.chequeNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    },
    setDrawerBankNarration(val) {
      const drawerBank = this.bankOptions.find(item => item.value === val)
      this.depositData.narration = `Chq dep.: ${drawerBank.label} Chq.No ${this.depositData.chequeNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    },
    setInstrumentNoNarration(val) {
      const drawerBank = this.bankOptions.find(item => item.value === this.depositData.drawerBank)
      this.depositData.drawerAccountNumber = val
      this.depositData.narration = `Chq dep.: ${drawerBank.label} Chq.No ${this.depositData.chequeNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    },
    setDrawerNumberNarration(val) {
      const drawerBank = this.bankOptions.find(item => item.value === this.depositData.drawerBank)
      this.depositData.drawerAccountNumber = val
      this.depositData.narration = `Chq dep.: ${drawerBank.label} Chq.No ${this.depositData.chequeNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    },
    setChequeNumberNarration(val) {
      this.depositData.chequeNumber = val
      const drawerBank = this.bankOptions.find(item => item.value === this.depositData.drawerBank)
      this.depositData.narration = `Chq dep.: ${drawerBank.label} Chq.No ${this.depositData.chequeNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        const response = await this.getUserBalance({ accountNumber: customer.accountNumber, permission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.availableBalance),
            withdrawableBalance: toBalance(data.withdrawableBalance),
            overdraftLimit: toBalance(data.overdraftLimit),
            ledgerBalance: toBalance(data.ledgerBalance),
            accountOfficer: data.accountOfficerName,
          }
        }
        if (data.memos !== null) {
          this.memoGetData = data.memos
          this.$root.$emit('bv::show::modal', 'memo-info-modal')
        }
        this.depositData.accountNumber = customer.accountNumber
        // this.depositData.branchCode = customer.branchCode
        this.depositData.narration = `Chq dep.: ${this.depositData.drawerBank} Chq.No ${this.depositData.drawerAccountNumber} deposited by ${this.depositData.drawerName} IFO ${this.depositData.accountNumber}`
        this.showCustomerInfo = true
        this.showSearchButton = true
        this.showBackButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit() {
      this.$refs.chequeDepositRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to initiate a cheque deposit of')
          this.confirm(this.chequeDepositAction, { text: `${areYouSure} ${toAmount(this.depositData.amount)} ?` })
        }
      })
    },
    async chequeDepositAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const postingApprovalModel = {
          amount: toKobo(this.depositData.amount),
          accountName: this.depositData.accountName,
          initiatedBy: '',
          approvedBy: '',
          postingType: 'ChequeDepositPosting',
        }

        const response = await this.postChequeDeposit({
          ...this.depositData,
          postingApprovalModel,
          dateOnCheque: toYearWithDate(this.depositData.dateOnCheque),
          instrumentNumber: this.depositData.chequeNumber,
          clearingDate: toYearWithDate(this.depositData.clearingDate),
          amount: toKobo(this.depositData.amount),
          drawerBankName: this.bankOptions.find(item => item.value === this.depositData.drawerBank).label,
          initiatedBy: this.userData.email,
        })

        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.showCustomerInfo = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          const successText = this.$t('Your Cheque deposit request was successful. Cheque deposit reference ID is')
          this.alertSuccess({ text: `${successText} ${data.referenceNumber}` })
          this.$router.push('cheque-deposit-list')
        }

        if (status === 200 && !data.isSuccessful) {
          const failedText = this.$t('Your Cheque deposit request failed. Reason:')
          this.alertError({ text: `${failedText} ${data.message}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.depositData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.referenceNumber = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.$router.push({
        name: 'cheque-deposit-list',
      })
    },

  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
